export const MainLayoutDependencyTypes = {
  MainLayoutPresenter: Symbol.for('MainLayoutPresenter'),
  MainLayoutService: Symbol.for('MainLayoutService'),
  CockpitNavigationService: Symbol.for('CockpitNavigationService'),
  MainLayoutSubscriptionSubscriberProgressService: Symbol.for('MainLayoutSubscriptionSubscriberProgressService'),
  MainLayoutStoreQuery: Symbol.for('MainLayoutStoreQuery'),
  MainLayoutStoreCommand: Symbol.for('MainLayoutStoreCommand'),
  MainLayoutNavigationRefreshService: Symbol.for('MainLayoutNavigationRefreshService'),
  MainLayoutClientGamesRefreshRequestedListener: Symbol.for('MainLayoutClientGamesRefreshRequestedListener'),
  MainLayoutGameCreationModalLifecycleListener: Symbol.for('MainLayoutGameCreationModalLifecycleListener'),
};
